import Error from './Error'

export default Error



// WEBPACK FOOTER //
// ./src/components/Error/index.js